import React from 'react';
// import './ImageBanner.css'; // 👈 create this CSS file

const ImageBanner = () => {

  return (
    <div>
      <div id="img-wrapper">
        <div className="placeholder"></div>
        <div className="placeholder"></div>
        <div className="placeholder"></div>
      </div>
    </div>
  );
};

export { ImageBanner };